/**
 * @generated SignedSource<<17b590530e3a7102480ead09dd88f26d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PageStatusQueryRelaySpike_content$data = {
  readonly status: string | null;
  readonly " $fragmentType": "PageStatusQueryRelaySpike_content";
};
export type PageStatusQueryRelaySpike_content$key = {
  readonly " $data"?: PageStatusQueryRelaySpike_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageStatusQueryRelaySpike_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PageStatusQueryRelaySpike_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "Content"
};

(node as any).hash = "2a176aa4faefb351edd19c84ee87b887";

export default node;
